import api from "./axios";
import {
  ClientPortalAreas,
  ClientPortalBilling,
  ClientPortalHoursMonth,
  ClientPortalOverview,
  ClientPortalProject,
  ClientPortalTask,
  ClientPortalTimesheetEntry,
} from "../interfaces/ClientPortal";

const BASE = "/ClientPortal";

/** Áreas liberadas para o usuário logado (interno em pré-visualização recebe tudo true). */
export async function getAreas(): Promise<ClientPortalAreas> {
  const { data } = await api.get(`${BASE}/areas`);
  return data;
}

export async function getOverview(clientId?: number): Promise<ClientPortalOverview> {
  const { data } = await api.get(`${BASE}/overview`, { params: { clientId } });
  return data;
}

export async function getProjects(clientId?: number): Promise<ClientPortalProject[]> {
  const { data } = await api.get(`${BASE}/projects`, { params: { clientId } });
  return Array.isArray(data) ? data : [];
}

export async function getHours(
  clientId?: number,
  months = 12
): Promise<ClientPortalHoursMonth[]> {
  const { data } = await api.get(`${BASE}/hours`, { params: { clientId, months } });
  return Array.isArray(data) ? data : [];
}

/** Tarefas do cronograma (área Projetos). Não usar /ProjectTask: exige tasks.manage e dá 403 ao cliente. */
export async function getTasks(clientId?: number): Promise<ClientPortalTask[]> {
  const { data } = await api.get(`${BASE}/tasks`, { params: { clientId } });
  return Array.isArray(data) ? data : [];
}

export async function getBillings(clientId?: number): Promise<ClientPortalBilling[]> {
  const { data } = await api.get(`${BASE}/billings`, { params: { clientId } });
  return Array.isArray(data) ? data : [];
}

/** Lançamentos detalhados de horas (timesheet) do cliente num mês/ano — para validação/export. */
export async function getTimesheetDetails(
  clientId: number | undefined,
  month: number,
  year: number
): Promise<ClientPortalTimesheetEntry[]> {
  const { data } = await api.get(`${BASE}/timesheetDetails`, {
    params: { clientId, month, year },
  });
  return Array.isArray(data) ? data : [];
}
